import Vue from 'vue';
import axios from 'axios';
// import { store } from '../store/store';
const BASE_URL = process.env.MIX_API_URL
const guest = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
            Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    }
});

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    }
});

guest.interceptors.request.use(config => {
    return config
});

guest.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        return Promise.reject(error);
    }
);

api.interceptors.request.use(config => {
    const token = localStorage.getItem('TOKEN');
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
});

api.interceptors.response.use(
    function(response) {
        return response;
    },

    function(error) {
        if (error.response.status === 401) {
            store.dispatch('logout');
        } else {
            store.commit('SET_isLoading', false);
            return Promise.reject(error);
        }
    }
);

Vue.prototype.$guest = guest;
Vue.prototype.$api = api;

export { guest, api };
